import React from 'react';
import Select from 'react-select';

import { PersonalViewSelectStyles } from 'constants';
import Styles from './ContentPlanner.module.scss';

const ProjectSelect = ({ setSelectedProject: setSelectedProjectParent, onViewModeChange, currentViewMode = 'general' }) => {

  const VIEW_OPTIONS = [
    {
      value: 'general',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>General View</p>
        </div>
      ),
    },
    {
      value: 'status',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Status View</p>
        </div>
      ),
    },
    {
      value: 'brand',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Brand View</p>
        </div>
      ),
    },
    {
      value: 'assignee',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Assignee View</p>
        </div>
      ),
    },
    {
      value: 'contentType',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Content Type View</p>
        </div>
      ),
    },
    {
      value: 'deadline',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Deadline View</p>
        </div>
      ),
    },
    {
      value: 'campaign',
      label: (
        <div className={'label__View ' + Styles.SelectLabel_View}>
          <p>Campaign View</p>
        </div>
      ),
    },
  ];
  return (
    <section className={Styles.Drawer}>
      <Select
        isSearchable={false}
        className={'Personal-View-Select'}
        classNamePrefix={'Personal-View-Select'}
        styles={PersonalViewSelectStyles}
        placeholder="General View"
        menuPlacement="auto"
        menuPortalTarget={document.body}
        onChange={(value) => {
          // Notify parent component of view mode change
          if (onViewModeChange) {
            onViewModeChange(value.value);
          }
        }}
        options={VIEW_OPTIONS}
        value={VIEW_OPTIONS.find(opt => opt.value === currentViewMode) || VIEW_OPTIONS[0]}
        defaultValue={VIEW_OPTIONS[0]}
      />
    </section>
  );
};

export default ProjectSelect;
